import { PROFILE_DETAILS, PROFILE_DETAILS_LOADING } from "./action_type"
import api from "../utils/index";

export const onJustReducerUpdate = (payload, reducerType) => {
  return ({ type: reducerType, payload })
}

export const onGetProfileDetails = (id) => (dispatch) => {
  dispatch({ type: PROFILE_DETAILS_LOADING, payload: true })
  api.get(`/user-profile?user_UUID=${id}`).then((res) => {
    dispatch({ type: PROFILE_DETAILS_LOADING, payload: false })
    dispatch({ type: PROFILE_DETAILS, payload: res.data })
  }).catch((err) => {
    dispatch({ type: PROFILE_DETAILS_LOADING, payload: false })
  })
}